import { LoadNewTicketSuggestion } from '@/javascript/domain/usecases'
import { AccessDeniedError, UnexpectedError } from '@/javascript/domain/errors'
import { HttpClient, HttpStatusCode } from '../protocols/http'

export class RemoteLoadNewTicketSuggestion implements LoadNewTicketSuggestion {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteLoadNewTicketSuggestion.Response>
  ) {}

  async load(description: string, files?: File[]): Promise<LoadNewTicketSuggestion.Model> {
    const formData = new FormData()
    formData.append('description', description)
    files?.forEach((file, index) => {
      formData.append(`attachments[${index}]`, file)
    })
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      body: formData
    })
    const response = httpResponse.body
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return response?.result || null
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}

export namespace RemoteLoadNewTicketSuggestion {
  export type Response = {
    result: {
      title: string
      description: string
      details: string
    }
  }
}
